import React from "react";
import { Row, Col } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import { HookFormRadioButton } from "components";

type TokenizationProps = {
	isLoading: boolean;
	sectionName: string;
	defaultValue?: { [key: string]: any };
};

const Tokenization = ({
	isLoading,
	sectionName,
	defaultValue,
}: TokenizationProps) => {
	const { register } = useFormContext();

	return (
		<>
			<p>Tokenization</p>
			<Row className="form-group">
				<Col md={2}>
					<HookFormRadioButton
						id={`${sectionName}.tokenizationYes`}
						name={`${sectionName}.isTsysTokenizationEnabled`}
						register={register}
						value="true"
						defaultCheckedByValue={
							defaultValue?.isTsysTokenizationEnabled
						}
						label="Yes"
						blurLoading={isLoading}
					/>
				</Col>
				<Col md={2}>
					<HookFormRadioButton
						id={`${sectionName}.tokenizationNo`}
						name={`${sectionName}.isTsysTokenizationEnabled`}
						register={register}
						value="false"
						defaultCheckedByValue={
							defaultValue?.isTsysTokenizationEnabled
						}
						label="No"
						blurLoading={isLoading}
					/>
				</Col>
			</Row>
		</>
	);
};

export default Tokenization;
